import CoreDialog from '@Core/Components/Dialog/CoreDialog'
import {
	LOCAL_STORAGE,
	SESSION_STORAGE,
	getAuthTokenSession,
	getDataSession,
	removeDataSession
} from '@Core/Helpers/Session'
import { Typography } from '@mui/material'
import Image from 'mui-image'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ROUTER_WORKSPACE_EXAM, TRANSLATE_WORKSPACE_EXAM } from '../configs/const'
import { WALLET_FEATURE } from '@Core/Components/const'
import { alertFeatureNotUsed, useWalletFeatureContext } from '@Core/Provider/CoreWalletFeature/WalletFeatureProvider'
import AlertUpgradeFeature from '@Core/Provider/CoreWalletFeature/components/AlertUpgradeFeature'
import { warningMsg } from '@Core/Helpers/Message'
import { useCoreAuth } from '@Core/Provider/CoreAuthProvider'
import { useCoreWorkspaceContext } from '@Core/Provider/CoreWorkspaceProvider'
import { get } from 'lodash'
import { isAfter } from 'date-fns'
// import PropTypes from 'prop-types'

const CreateExamOptionContext = React.createContext({
	handleOpenCreateOption: () => {}
})

export const useCreateExamOptionContext = () => useContext(CreateExamOptionContext)

const CreateExamOptionProvider = props => {
	const [open, setOpen] = useState(false)
	const { t } = useTranslation(TRANSLATE_WORKSPACE_EXAM)
	const navigate = useNavigate()

	const { user } = useCoreAuth()
	const { currentWorkspace } = useCoreWorkspaceContext()

	const getCreateExamAIUrl = () => {
		// const created_at = new Date(user?.created_at)
		// const date = new Date('2025-12-10T00:00:00Z')
		// const checkAfter = isAfter(created_at, date)
		// // console.log('============= user', created_at, checkAfter)
		// const confirm_use_ai_agent_v2 = getDataSession(LOCAL_STORAGE, 'confirm_use_ai_agent_v2')
		// if ([1, 435186].includes(currentWorkspace?.id) || checkAfter || confirm_use_ai_agent_v2 === 'yes') {
		const path = '/studio/create-exam'
		const school_id = get(user, 'onboarding_data.school_id', undefined)
		const query = {
			access_token: getAuthTokenSession()?.access_token,
			school_id,
			bizapp: 'eduquiz',
			channel_id: currentWorkspace?.id
		}
		const searchParams = new URLSearchParams(query)
		const queryString = searchParams.toString()

		const fullUrl = `https://ai.eduquiz.io.vn${path}?${queryString}`
		// console.log('============= query', query)
		return fullUrl
		// }
		// return ROUTER_WORKSPACE_EXAM.createWithAI
	}

	// const { featureCreateExam } = useWalletFeatureContext()

	const toggleOpen = () => {
		setOpen(prev => !prev)
	}

	const options = [
		// {
		// 	label: t('Bộ câu hỏi'),
		// 	link: ROUTER_WORKSPACE_EXAM.createWithQuestionPool('new'),
		// 	subText: t('Tạo đề thi nhanh từ bộ câu hỏi có sẵn'),
		// 	image: '/assets/images/exam/c_pool_question.png'
		// },

		{
			key: 'create-ai',
			label: t('Trợ lý AI'),
			link: getCreateExamAIUrl(),
			subText: t('Tạo đề thi nhanh hơn với trợ lý AI'),
			image: '/assets/images/exam/c_ai.png'
		},
		{
			key: 'create-text',
			label: t('Văn bản'),
			link: ROUTER_WORKSPACE_EXAM.createWithText,
			subText: t('Tạo đề thi nhanh bằng cách soạn thảo văn bản'),
			image: '/assets/images/exam/c_text.png'
		},
		{
			key: 'create-editor',
			label: t('Trình soạn thảo'),
			link: ROUTER_WORKSPACE_EXAM.createWithBasic,
			subText: t('Tạo đề thi từ đầu và chỉnh sửa thủ công'),
			image: '/assets/images/exam/c_editor.png'
		}

		// {
		// 	label: t('Format'),
		// 	link: '/',
		// 	subText: t('Create from existing format (TOEIC, IELTS,..)'),
		// 	image: '/assets/images/exam/c_text.png'
		// }
	]

	const renderDialog = () => {
		return (
			<CoreDialog
				open={open}
				handleClose={toggleOpen}
				maxWidth="md"
				dialogTitle={t('Tạo đề thi mới')}
				dialogContent={
					<div className="flex flex-col">
						{/* {!featureCreateExam.canUseFeature() && (
							<AlertUpgradeFeature
								className="mb-2"
								slug={WALLET_FEATURE.create_exam.slug}
								showButton
								onClick={() => setOpen(false)}
							/>
						)} */}
						<div className="flex flex-col sm:flex-row gap-4 bg-[#EDF2FF] p-4">
							{options.map(item => (
								// eslint-disable-next-line jsx-a11y/no-static-element-interactions
								<div
									key={item.label}
									onClick={() => {
										// if (featureCreateExam.canUseFeature()) {
										if (item.link.indexOf('https') === 0) {
											window.location.href = item.link
										} else {
											navigate(item.link)
											toggleOpen()
											removeDataSession(SESSION_STORAGE, 'new_exam')
										}

										// } else {
										// 	alertFeatureNotUsed()
										// 	toggleOpen()
										// }
									}}
									className="sm:w-1/3 bg-white group cursor-pointer transition-all duration-300 hover:scale-[1.04] rounded-xl shadow-md p-2 flex flex-col gap-2 justify-center hover:bg-secondaryGradient "
								>
									<Typography
										component="p"
										variant="M16"
										className="text-center group-hover:text-white"
									>
										{item.label}
									</Typography>
									<Typography
										component="p"
										sx={{ minHeight: '40px' }}
										variant="M14"
										className="text-center text-[#71727D] group-hover:text-white"
									>
										{item.subText}
									</Typography>
									<div>
										<Image className="w-[50%]" src={item.image} alt="eduquiz.io" />
									</div>
								</div>
							))}
						</div>
					</div>
				}
			/>
		)
	}

	return (
		<CreateExamOptionContext.Provider value={{ handleOpenCreateOption: toggleOpen }}>
			{props.children}
			{renderDialog()}
		</CreateExamOptionContext.Provider>
	)
}

// CreateExamOptionProvider.defaultProps = {}

// CreateExamOptionProvider.propTypes = {}

export default React.memo(CreateExamOptionProvider)
